export async function handlePreview(manager) {
  if (h.isTrue(manager.get('use_placeholder'))) {
    let data = makeDataSample(0)
    manager.reload(data)
  }
  else {
    await manager.loadData();
  }
}

export function makeDataSample() {
  const prices = [100000, 250000, 500000, 1000000, 10000000];
  const progress = [0, 5, 12, 20, 50, 75, 90];
  const titles = [
    'Naik Haji',
    'Membeli Rumah Impian',
    'Upgrade Laptop',
    'Kuliah S3 di LN'
  ];

  const targetPrice = h.selectRandom(prices);
  const targetProgress = h.selectRandom(progress);
  const title = h.selectRandom(titles); 
  const targetReceived = targetProgress * targetPrice / 100;

  return {
    pageUrl : "trakteer.id/seseorang",
    targetPrice : targetPrice,
    targetProgress : targetProgress,
    targetReceived : targetReceived,
    targetTitle : title,
    targetValue : `${h.formatPrice(targetReceived)} / ${h.formatPrice(targetPrice)}`,
  };
};